'use client';
import React, { useEffect } from 'react';
import { ISearchFieldProps } from '../interfaces';
import styled from '@benzinga/themetron';
import { Icon } from '@benzinga/core-ui';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';

const SearchField = ({ onSearch, placeholder = 'Search...', search, tagsMode = false }: ISearchFieldProps) => {
  const [searchQuery, setSearchQuery] = React.useState('');
  const [tags, setTags] = React.useState<string[]>([]);

  useEffect(() => {
    setSearchQuery(search);
  }, [search]);

  function onSearchQueryChange(event: any): void {
    setSearchQuery(event.target.value);
    if (event.target.value.trim() === '') {
      onSearch('');
    }
  }

  function handleSearchKeyDown(event: any): void {
    if (event.key === 'Enter') {
      handleSearch();
    }
  }

  function handleSearch(): void {
    if (tagsMode) {
      if (searchQuery.length) {
        const localTags = [...tags, searchQuery.toUpperCase()];

        setTags(localTags);
        onSearch(localTags);
        setSearchQuery('');
      }
    } else {
      onSearch(searchQuery);
    }
  }

  function removeTag(index: number): void {
    const localTags = [...tags];

    localTags.splice(index, 1);
    setTags(localTags);

    onSearch(localTags);
  }

  const Tags = () => {
    return (
      <>
        {tags.map((item, index) => {
          return (
            <div className="search-tag" key={index} onClick={() => removeTag(index)}>
              {item} <i className="fa fa-times" />
            </div>
          );
        })}
      </>
    );
  };

  return (
    <SearchBarWrapper className="bz3-search-bar-wrapper">
      <div className="bz3-search-field" style={{ background: 'white' }}>
        <div className="bz3-search-field__tags-wrapper">
          {tagsMode ? (
            <div className="bz3-search-field__tags">
              <Tags />
            </div>
          ) : (
            ''
          )}

          <input
            className="bz3-search-field__input"
            onChange={onSearchQueryChange}
            onKeyDown={handleSearchKeyDown}
            placeholder={placeholder}
            type="text"
            value={searchQuery}
          />
        </div>
        <button className="bz3-search-field__btn" onClick={handleSearch} type="button">
          <Icon icon={faSearch} />
        </button>
      </div>
    </SearchBarWrapper>
  );
};

export default SearchField;

export const SearchBarWrapper = styled.div`
  .bz3-search-field {
    position: relative;
    max-width: 180px;

    &__btn {
      height: 40px;
      width: 40px;
      border: 0;
      background: #fa8418;
      color: #fff;
      font-size: 14px;
      position: absolute;
      top: 2px;
      right: 2px;
    }

    &__tags-wrapper {
      border: 1px solid #e5e5e5;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      height: auto;
      min-height: 44px;
      padding: 0 50px 0 15px;
      border: 1px solid #e5e5e5;
      border-radius: 0;
      box-shadow: none;
      margin: 0;
    }

    &__input {
      border: none;
      width: 100%;
      padding: 0;
      font-size: 12px;

      &::placeholder {
        color: #7b7b7b;
      }

      &:focus {
        outline: none;
        box-shadow: none;
      }
    }
  }
`;
